export enum ExtraStatus {
  applied = 'applied',
  failed = 'failed',
  draft = 'draft',
}
